import React, { useState } from 'react';
import Faq, { FAQ } from './faq/faq';
import { Card } from 'src/components';

import './faqs.scss';

type FaqsProps = {
  faqs: FAQ[];
  className?: string;
  automationIdPrefix: string;
  faqOnClick: (topic: string) => void;
};

export default function Faqs({ faqs, className, faqOnClick }: FaqsProps) {
  const [indexExpanded, setIndexExpanded] = useState<number | null>(null);

  return (
    <Card data-testid="faq-box" className={`FAQs ${className}`} cardTitle="FAQs">
      {faqs.map((faq, index) => (
        <Faq
          key={index}
          index={index}
          faq={faq}
          expanded={indexExpanded === index}
          setExpanded={(expanded) => {
            if (expanded) {
              setIndexExpanded(index);
            } else {
              setIndexExpanded(null);
            }
          }}
          faqOnClick={faqOnClick}
        />
      ))}
    </Card>
  );
}
